<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { ElCol, ElRow } from 'element-plus'

import { Alert } from '@/shared/ui/Alert'
import { Button } from '@/shared/ui/Button'
import { Icon } from '@/shared/ui/Icon'
import { ImagePreview } from '@/shared/ui/ImagePreview'
import { Inline } from '@/shared/ui/Inline'
import { Modal } from '@/shared/ui/Modal'
import { Stack } from '@/shared/ui/Stack'
import { SummaryCard } from '@/shared/ui/SummaryCard'
import { Check } from '@/shared/icons'

import lowBalanceImage from '../assets'
import {
  PLAN_FEATURES,
  PLAN_FEE_AMOUNT,
  PLAN_FEE_PERCENT
} from '../model/content'

const BALANCE_TOP_UP_ROUTE_NAME = 'balance-top-up'

defineProps<{
  modelValue?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const route = useRoute()
const router = useRouter()

function topUp() {
  emit('close')
  if (route.name !== BALANCE_TOP_UP_ROUTE_NAME) {
    router.push({ name: BALANCE_TOP_UP_ROUTE_NAME })
  }
}
</script>

<template>
  <Modal
    :model-value="modelValue"
    title="Your balance is running out"
    width="600px"
    @close="emit('close')"
  >
    <ElRow :gutter="20">
      <ElCol :xs="24" :sm="16">
        <Stack>
          <SummaryCard
            title="Your payment plan"
            :value="`$${PLAN_FEE_AMOUNT}`"
            :caption="`monthly +${PLAN_FEE_PERCENT}% of Ad revenue`"
          >
            <template #footer>
              <Stack :gap="8">
                <Inline
                  v-for="feature in PLAN_FEATURES"
                  :key="feature"
                  :gap="8"
                  align="center"
                >
                  <Icon><Check /></Icon>
                  {{ feature }}
                </Inline>
              </Stack>
            </template>
          </SummaryCard>

          <Alert type="warning">
            Please keep in mind that the codes will not be active if your
            balance is empty
          </Alert>
        </Stack>
      </ElCol>

      <ElCol :xs="0" :sm="8">
        <ImagePreview :src="lowBalanceImage" block :max-height="320" />
      </ElCol>
    </ElRow>

    <template #footer>
      <Button type="primary" @click="topUp">Top-up balance</Button>
      <Button @click="emit('close')">Skip</Button>
    </template>
  </Modal>
</template>
